<div class="flex h-[500px] w-full justify-around sm:h-fit sm:flex-col sm:items-center sm:gap-14">
    @if (sentimentsBarChartData()) {
        <div class="w-3/5 sm:w-full">
            <app-sentiments-bar-chart [segments]="sentimentsBarChartData()!"></app-sentiments-bar-chart>
        </div>
    }
    @if (sentimentsDoughnutChartData()) {
        <div class="flex w-2/5 items-center justify-center">
            <app-sentiments-doughnut-chart [aggregatedData]="sentimentsDoughnutChartData()!"></app-sentiments-doughnut-chart>
        </div>
    }
</div>
